export type SimulationDecision = "allow" | "deny" | "require_approval" | "modify";

export type SimulationRecord = {
  requestId: string;
  actionType: string;
  liveDecision: SimulationDecision;
  draftDecision: SimulationDecision;
  decisionChanged: boolean;
  draftReasonCode: string;
};

export type SimulationSummary = {
  totalEvaluated: number;
  decisionFlips: number;
  byDraftDecision: Record<SimulationDecision, number>;
  records: SimulationRecord[];
};

export const simulationDecisionBadgeVariant = (
  d: SimulationDecision | string
): "success" | "destructive" | "warning" | "secondary" => {
  if (d === "allow") return "success";
  if (d === "deny") return "destructive";
  if (d === "require_approval") return "warning";
  return "secondary";
};

export const simulationDecisionLabel: Record<SimulationDecision, string> = {
  allow: "Allow",
  deny: "Deny",
  require_approval: "Pending approval",
  modify: "Modify required"
};

export const formatSimulationDecision = (d: string) =>
  simulationDecisionLabel[d as SimulationDecision] ?? d;
